/**
 * Feature flag for the Compact layout (OCT-5366). Off in production until the
 * sync export ships and Safari stops freezing on large maps (OCT-5438): with it
 * off the option is hidden and a saved compact project renders as Default.
 *
 * Only the build decides: enabling it in production is a release, not a
 * per-browser switch.
 */
export const isCompactLayoutEnabled = (): boolean =>
  import.meta.env.VITE_COMPACT_LAYOUT === 'true'

export const isCompactLayout = (tree: string) => tree === 'compact'
